module.exports = __webpack_public_path__ + "img/01.53293d3a.png";